import { DispositionRecommendedAction } from '@app/advisor-shared';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { smartDocParamCondition_DispositionType_Admit, smartDocParamCondition_DispositionType_Discharge } from '@app/advisor-content-shared';
import { StaticLogger } from '@nu-art/ts-common';
import { getNoteTemplateId } from './get-note-template-id.js';
import { ModuleFE_AdvisorAnalytics } from '../_analytics/consts.js';
export const fetchDispositionNote = async (dispositionType, openMethod, workingDiagnosis) => {
    const noteTemplateId = getNoteTemplateId();
    if (!noteTemplateId)
        return;
    const request = { noteTemplateId };
    if (dispositionType !== DispositionRecommendedAction.ENGAGED_ENCOUNTER) {
        request.dynamicParams = {
            dispositionType: dispositionType === DispositionRecommendedAction.ADMIT
                ? smartDocParamCondition_DispositionType_Admit
                : smartDocParamCondition_DispositionType_Discharge,
        };
        if (workingDiagnosis)
            request.dynamicParams.workingDiagnosis = workingDiagnosis.pathway._id;
    }
    try {
        const latestSummary = await ModuleFE_EMInterface.vv1.smartNote.get(request).executeSync();
        ModuleFE_AdvisorAnalytics.trigger.note.note_open({
            noteId: noteTemplateId,
            openMethod: openMethod,
            elapsed_ms: 0,
            dispositionType: dispositionType,
            workingDiagnosisId: workingDiagnosis?.pathway._id,
            workingDiagnosisLabel: workingDiagnosis?.getLabel(),
        });
        return latestSummary.note;
    }
    catch (err) {
        StaticLogger.logError('fetchDispositionNote', 'Error getting latest smart note', err);
    }
};
//# sourceMappingURL=fetch-disposition-note.js.map